globalThis.regeneratorRuntime = undefined;



//////////////////
// WEBPACK FOOTER
// ./regenerator.js
// module id = +81g
// module chunks = 04af